import type from './types/usercenter'
import service from '@/api/usercenter'

const state = {}

const actions = {
  [type.getStationBaseList] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.getStationBaseList(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [type.postArealRainfallInfo] (_, params) {
    return new Promise((resolve, reject) => {
      service.postArealRainfallInfo(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [type.getArealRainfallList] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.getArealRainfallList(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [type.postCollocationStationInfo] (_, params) {
    return new Promise((resolve, reject) => {
      service.postCollocationStationInfo(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [type.getConfiguredArealRainfallStation] (_, params) {
    return new Promise((resolve, reject) => {
      service.getConfiguredArealRainfallStation(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [type.getlog] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.getlog(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
